import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

/**
 * Diálogo de confirmación reutilizable.
 *
 * Reemplaza a `window.confirm()` (que no funciona dentro de iframes).
 *
 * Props:
 *   - open: boolean
 *   - onOpenChange: (open: boolean) => void
 *   - title: string
 *   - description: ReactNode (puede incluir <strong>, <br/>, etc.)
 *   - confirmText: string (default "Eliminar")
 *   - cancelText: string (default "Cancelar")
 *   - destructive: boolean (default true) — pinta el botón de confirmar en rojo
 *   - loading: boolean — deshabilita el botón mientras corre la acción
 *   - onConfirm: () => void | Promise<void>
 *   - testId: string — prefijo para data-testid
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText = 'Eliminar',
  cancelText = 'Cancelar',
  destructive = true,
  loading = false,
  onConfirm,
  testId = 'confirm',
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={`${testId}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>{description}</div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>{cancelText}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className={destructive ? 'bg-rose-600 text-white hover:bg-rose-700' : ''}
            data-testid={`${testId}-accept`}
          >
            {loading ? 'Procesando…' : confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmDialog;
